import { render, staticRenderFns } from "./DataSourceSelectComponent.vue?vue&type=template&id=f25a7dc6"
import script from "./DataSourceSelectComponent.vue?vue&type=script&lang=js"
export * from "./DataSourceSelectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports